<template>
    <div class="modal-overlay" @click.self="closeModal">
        <div class="modal-content" @click.stop>
            <input type="text" v-model="firstName" class="input-field" required :placeholder="$t('reply.firstName')">
            <input type="text" v-model="lastName" class="input-field" required :placeholder="$t('reply.lastName')">
            <h4 class="title">{{ $t("reply.title") }}</h4>
            <textarea
                v-model="message"
                :placeholder="$t('reply.textAreaPlaceholder')"
                class="input-field"
                required
            ></textarea>
            <div class="btns-row">
                <button @click="sendMessage" :disabled="!isReplyReady">
                    {{ isLoading ? $t("reply.sending") : $t("rgpd.submit") }}
                </button>
                <button @click="closeModal">{{ $t("general.cancel") }}</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: "ReplyModal",
    props: {
        replyToVideo: {
            type: Function,
            required: true
        }
    },

    data() {
        return {
            isLoading: false,
            message: "",
            firstName: "",
            lastName: ""
        };
    },

    computed: {
        isReplyReady() {
            return this.message && this.firstName && this.lastName;
        }
    },

    methods: {
        closeModal() {
            this.resetFields();
            // Emit an event to notify the parent component to close the modal
            this.$emit("close");
        },

        sendMessage() {
            this.isLoading = true;

            this.replyToVideo(this.message, this.firstName, this.lastName)
                .catch(() => {
                    this.isLoading = false;
                })
                .then(() => {
                    this.isLoading = false;
                    setTimeout(() => this.closeModal(), 1500);
                })
        },
        resetFields() {
            this.message = "";
            this.isLoading = false;
        }
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    width: 80%;
    height: auto;
    background-color: var(--background);
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    position: relative;
    box-sizing: border-box;
}

.title {
    margin-top: 0;
    color: var(--screenTextColor);
}

.btns-row {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}

.input-field {
    width: 100%;
    padding: 10px;
    margin-bottom: 12px;
    border: 1px solid var(--secondary);
    border-radius: 8px;
    resize: none;
    box-sizing: border-box;
}

textarea {
    width: 100%;
    height: 30vh;
    resize: none;
}

/* Button Styles */
button {
    margin-top: 10px;
    padding: 10px 20px;
    background-color: var(--secondary);
    color: var(--buttonTextColor);
    border: none;
    border-radius: 16px;
    cursor: pointer;
    transition: box-shadow 0.3s;
}

button:hover {
    /* background-color: var(--secondary) + #a3a3a3; */
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.3);
}

button:focus {
    outline: none;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.5);
}

button:active {
    box-shadow: 0 1px 4px var(--secondary);
}

button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    box-shadow: none;
}
</style>
